import { apiV2 } from "../v2";
import { adminParamNameRequest, getAdminParamsResponse, getAdminParamValueResponse, putAdminParamRequest } from "./params.dto";

export const getAdminParamsApi = apiV2("GET", "/admin/params").withResponse(getAdminParamsResponse);

export const getAdminParamValueApi = apiV2("GET", "/admin/params/:name/value").withRequest(adminParamNameRequest).withResponse(getAdminParamValueResponse);

export const putAdminParamApi = apiV2("PUT", "/admin/params").withRequest(putAdminParamRequest).withResponse(getAdminParamsResponse);

export const deleteAdminParamApi = apiV2("DELETE", "/admin/params/:name").withRequest(adminParamNameRequest).withResponse(getAdminParamsResponse);
